import type { NavigationProp } from '@react-navigation/native';
import { navigateInShell } from './rootNavigation';
import { showInfo } from '../../shared/ui/appToast';

type FiscalHubTab = 'status' | 'setup' | 'branches';

export type OpenFiscalDestinationOptions = {
  currentBranchId?: string | null;
  arcaIntegrationsEnabled?: boolean;
  initialTab?: FiscalHubTab;
};

/** Navega al instante; FiscalHub carga el contexto y abre el wizard si hace falta. */
export function openFiscalDestination(
  navigation: NavigationProp<any>,
  options: OpenFiscalDestinationOptions = {}
): void {
  if (options.arcaIntegrationsEnabled === false) {
    showInfo('No disponible', 'ARCA está apagado por ahora.');
    return;
  }

  navigateInShell(navigation, 'FiscalHub', {
    initialTab: options.initialTab ?? 'status',
    autoOpenWizard: true,
  });
}
